import { useEffect, useState } from 'react';
import { ApiError, api } from '../api.ts';

/**
 * Вход и первичная настройка на одном экране: пока владельца нет, форма
 * заводит его, дальше — обычный вход. Отдельного экрана регистрации не нужно,
 * он показался бы ровно один раз за жизнь приложения.
 */
export function LoginScreen({ onSignedIn }: { onSignedIn: () => void }) {
  const [setupNeeded, setSetupNeeded] = useState<boolean | null>(null);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api
      .setupNeeded()
      .then((r) => setSetupNeeded(r.setupNeeded))
      .catch(() => setSetupNeeded(false));
  }, []);

  async function submit(event: React.FormEvent) {
    event.preventDefault();
    setError(null);
    setBusy(true);
    try {
      if (setupNeeded) {
        await api.register(email, password);
      } else {
        await api.login(email, password);
      }
      onSignedIn();
    } catch (e) {
      // Владелец мог появиться, пока экран был открыт — например, его завели
      // с другого устройства. Тогда форма обязана превратиться во вход,
      // а не повторять отказ на каждое нажатие.
      if (e instanceof ApiError && e.status === 409) {
        setSetupNeeded(false);
        setError('Владелец уже зарегистрирован — войдите своим паролем');
      } else {
        setError(e instanceof Error ? e.message : 'Не удалось войти');
      }
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="app">
      <div className="scroll form-narrow">
        <h1 className="brand">druzza</h1>
        <p className="muted small">
          {setupNeeded
            ? 'Коллекции ещё нет. Заведите владельца — это делается один раз.'
            : 'Личный каталог минералогической коллекции.'}
        </p>

        <form onSubmit={submit}>
          <div className="label-key">Адрес</div>
          <input
            className="field-input"
            type="email"
            value={email}
            autoComplete="username"
            required
            onChange={(e) => setEmail(e.target.value)}
          />

          <div className="label-key">Пароль</div>
          <input
            className="field-input"
            type="password"
            value={password}
            autoComplete={setupNeeded ? 'new-password' : 'current-password'}
            required
            minLength={10}
            onChange={(e) => setPassword(e.target.value)}
          />
          {setupNeeded && <div className="hint">Не короче 10 символов</div>}

          {error && (
            <div className="notice notice--danger" style={{ marginTop: 'var(--space-4)' }}>
              {error}
            </div>
          )}

          <button
            className="btn btn--primary btn--full"
            style={{ marginTop: 'var(--space-5)' }}
            disabled={busy}
          >
            {busy ? 'Минуту…' : setupNeeded ? 'Завести владельца' : 'Войти'}
          </button>
        </form>
      </div>
    </div>
  );
}
